import React from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const DateTimePicker = ({ value, onChange,disabledDate }) => {
    const initialValue = dayjs(value);
    return (<DatePicker 
        //disabledDate={disabledDate} 
        value={initialValue} 
        style={{width:"100%"}} onChange={(val)=>{
        onChange(val.format("YYYY-MM-DD"));
        console.log(val);
    }} />);
}

export default DateTimePicker